<template>
  <div class="basketball_scheduleDetail_matchPanel">
    <div class="row1" :class="logoRatio">
      <span class="row1_left teamItem">
        <span class="teamItem_clomun1">
          <span
            class="teamItem_clomun1_row1"
            v-text="matchInfor.homeTeam"
          ></span>
          <span class="teamItem_clomun1_row2">
            <span class="winLossText" v-text="matchInfor.homeWinLoss"></span>
          </span>
        </span>
        <span class="teamItem_clomun2">
          <img v-if="matchInfor.homeTeamLogo" :src="matchInfor.homeTeamLogo" />
        </span>
        <!-- <span
          class="teamItem_clomun3"
          v-text="matchInfor.homeTeamPoints"
        ></span> -->
        <span class="teamItem_clomun3">
          <NumberScrolling
            :tarVal="matchInfor.homeTeamPoints"
            :unit="''"
          ></NumberScrolling>
        </span>
      </span>
      <span class="row1_center">
        <span
          class="row1_center_row1"
          v-text="`${matchInfor.leagueName} ${matchInfor.gameDateWeb}`"
        ></span>
        <span class="row1_center_row2">
          <span
            class="matchStatusName"
            :class="`matchStatus_${matchInfor.matchStatus}`"
            v-text="
              _playingTimerWeb(matchStatusNameArr[matchInfor.matchStatus - 1])
            "
          ></span>
        </span>
      </span>
      <span class="row1_right teamItem">
        <span class="teamItem_clomun1">
          <span
            class="teamItem_clomun1_row1"
            v-text="matchInfor.awayTeam"
          ></span>
          <span class="teamItem_clomun1_row2">
            <span class="winLossText" v-text="matchInfor.awayWinLoss"></span>
          </span>
        </span>
        <span class="teamItem_clomun2">
          <img v-if="matchInfor.awayTeamLogo" :src="matchInfor.awayTeamLogo" />
        </span>
        <!-- <span
          class="teamItem_clomun3"
          v-text="matchInfor.awayTeamPoints"
        ></span> -->
        <span class="teamItem_clomun3">
          <NumberScrolling
            :tarVal="matchInfor.awayTeamPoints"
            :unit="''"
          ></NumberScrolling>
        </span>
      </span>
    </div>
    <div class="row2" v-if="periodsArr && periodsArr.length > 0">
      <span class="row2_table_row" v-for="item in periodsArr" :key="item.key">
        <span class="row2_table_row_cloum" v-text="item.name"></span>
        <!-- <span
          class="row2_table_row_cloum"
          :class="periodItem.class"
          v-for="periodItem in item.arr"
          :key="periodItem.index"
          v-text="periodItem.val"
        ></span> -->
        <span
          class="row2_table_row_cloum"
          :class="periodItem.class"
          v-for="periodItem in item.arr"
          :key="periodItem.index"
        >
          <NumberScrolling
            :tarVal="periodItem.val"
            :unit="''"
          ></NumberScrolling>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import NumberScrolling from '@components/compreSportsMeet/html/components/NumberScrolling'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'basketball_scheduleDetail_matchPanel',
  mixins: [cup_base_data_mixin],
  components: {
    NumberScrolling,
  },
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        leagueName: '',
        gameDateWeb: '',
        matchStatus: '',
        homeWinLoss: '',
        awayWinLoss: '',
        homeId: '',
        homeTeam: '',
        homeTeamPoints: '-',
        homeTeamLogo: '',
        awayId: '',
        awayTeam: '',
        awayTeamPoints: '-',
        awayTeamLogo: '',
        currentPeriodName: '',
        timeMinutes: 0,
        timeSeconds: 0,
      }),
    },
    periodsArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    logoRatio: {
      type: String,
      default: '', //默认走联赛 正方形
    },
  },
  data() {
    return {
      matchStatusNameArr: [
        '未开始',
        '进行中',
        '取消',
        '已完赛',
        '延期',
        '待定',
      ],
    }
  },
  methods: {
    _playingTimerWeb(matchStatusText) {
      // console.debug(
      //   'matchStatusText:',
      //   matchStatusText,
      //   matchStatusText === '进行中',
      //   this.matchInfor
      // )
      let str = matchStatusText
      if (matchStatusText === '进行中') {
        let m =
          this.matchInfor.timeMinutes < 10
            ? '0' + this.matchInfor.timeMinutes
            : this.matchInfor.timeMinutes
        let s =
          this.matchInfor.timeSeconds < 10
            ? '0' + this.matchInfor.timeSeconds
            : this.matchInfor.timeSeconds
        str = `${this.matchInfor.currentPeriodName} ${m}:${s}`
      }
      return str
    },
  },
}
</script>

<style lang="scss" scoped>
.basketball_scheduleDetail_matchPanel {
  position: relative;
  height: 20.833vw;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .row1 {
    width: 100%;
    height: 6.25vw;
    padding-top: 3.2vw;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: flex-start;
    &.WH-3V2 {
      .teamItem {
        .teamItem_clomun2 {
          width: 7.29vw;
          img {
            object-fit: fill;
          }
        }
        .teamItem_clomun3 {
          width: calc(100% - 11.1vw - 7.29vw - 1.388vw);
          padding: 0 1.563vw;
        }
      }
    }
    .teamItem {
      width: calc(50% - 11.1vw);
      display: flex;
      display: -webkit-flex;
      align-items: flex-start;
      .teamItem_clomun1 {
        width: 11.1vw;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        flex-direction: column;
        color: var(--mixtmt_whiteColor);
        text-align: center;
        .teamItem_clomun1_row1 {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: auto;
          min-height: 4.86vw;
          font-size: 1.688vw;
          font-weight: bold;
        }
        .teamItem_clomun1_row2 {
          width: 100%;
          text-align: center;
          .winLossText {
            display: inline-block;
            width: auto;
            padding: 0 0.694vw;
            font-size: 1.11vw;
            line-height: 2.083vw;
            background-color: var(--mixtmt_greyColor2);
            color: var(--mixtmt_whiteColor);
            border-radius: 1.25vw;
          }
        }
      }
      .teamItem_clomun2 {
        display: block;
        padding: 0.2778vw;
        width: 4.86vw;
        height: 4.86vw;
        background-color: var(--mixtmt_greyColor9);
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
          background-color: var(--mixtmt_whiteColor);
        }
      }
      .teamItem_clomun3 {
        width: calc(100% - 11.1vw - 4.86vw - 1.388vw);
        font-size: 2.778vw;
        padding: 0 2.778vw;
        line-height: 4.86vw;
        color: var(--mixtmt_whiteColor);
        font-weight: bold;
      }
    }
    .row1_left {
      justify-content: flex-start;
      .teamItem_clomun2 {
        margin-left: 1.388vw;
      }
    }
    .row1_right {
      flex-direction: row-reverse;
      .teamItem_clomun2 {
        margin-right: 1.388vw;
      }
      .teamItem_clomun3 {
        text-align: right;
      }
    }
    .row1_center {
      width: 22.2vw;
      height: 4.86vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      color: var(--mixtmt_whiteColor);
      .row1_center_row1 {
        width: 100%;
        font-size: 0.974vw;
        line-height: 1.66vw;
        text-align: center;
      }
      .row1_center_row2 {
        width: 100%;
        padding-top: 0.374vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: flex-start;
        .matchStatusName {
          width: auto;
          padding: 0 0.694vw;
          font-size: 1.11vw;
          text-align: center;
          line-height: 1.944vw;

          border-radius: 0.138vw;
          &.matchStatus_1 {
            background-color: rgba(220, 28, 52, 1);
          }
          &.matchStatus_2 {
            background-color: rgba(0, 217, 56, 1);
          }
          &.matchStatus_3 {
            background-color: rgba(255, 255, 255, 0.4);
          }
          &.matchStatus_4 {
            background-color: rgba(46, 112, 188, 1);
          }
          &.matchStatus_5 {
            background-color: rgba(229, 103, 43, 1);
          }
          &.matchStatus_6 {
            background-color: rgba(229, 163, 43, 1);
          }
        }
      }
    }
  }
  .row2 {
    position: absolute;
    bottom: 4vw;
    left: 50%;
    margin-left: -50%;
    width: 100%;
    height: 7vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    .row2_table_row {
      width: auto;
      height: 2.083vw;
      line-height: 2.083vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      color: var(--mixtmt_whiteColor);
      font-weight: bold;
      &:first-child {
        border-bottom: 1px solid var(--mixtmt_whiteColor);
        color: var(--mixtmt_greyColor11);
      }
      .row2_table_row_cloum {
        width: 3.47vw;
        text-align: center;
        &:first-child {
          width: 6.94vw;
          text-align: left;
          color: var(--mixtmt_whiteColor);
        }
        &.lossColor {
          color: var(--mixtmt_greyColor9);
        }
      }
    }
  }
}

.mixtmt_pc .basketball_scheduleDetail_matchPanel {
}
</style>
